export enum ROLES {
  CONSULTANT = 1,
  COLLABORATOR = 2,
  FINAL_CONSUMER = 3,
  SALES_FORCE = 6
}
